module.exports = __webpack_public_path__ + "media/images/flags/64/Finland-f7f10b47949ec09773924a6920121f47.png";